/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   WalkScore Bizo
 */

import type { RawWalkscore, Walkscore as WalkscoreType } from '@zcode/state-type'
import { Bizo, autoclass } from '../../shared/bizos/base'

const DEFINITION = {
  description: 'description',
  walkscore: 'walkscore',
} as const

const Walkscore = autoclass<WalkscoreType, RawWalkscore>(
  'WalkScore',
  class WalkScore extends Bizo<WalkscoreType, RawWalkscore> {},
  DEFINITION
)
export type Walkscore = InstanceType<typeof Walkscore>

export default Walkscore
